import type { AccommodationType } from '@libs/trip-planner-interfaces';
import { HOTEL_TYPES } from '@libs/trip-planner-interfaces';

export function isTicketActivity(productType: AccommodationType): boolean {
  return productType === 'Ticket';
}

export function isGolfActivity(productType: AccommodationType): boolean {
  return productType === 'Golf';
}

export function isAccommodation(productType?: AccommodationType): boolean {
  if (!productType) {
    return false;
  }
  return HOTEL_TYPES.includes(productType);
}
